import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Получение конечного идентификатора тарифа по набору подписок.
 *
 * @param salePackageId number
 * @param subscriptions number[]
 * @link https://master.api-tariffs.sandbox.d2c.r-one.io/docs#/Tariffs/TariffsController_getPackageIdBySubscriptions
 */
const getPackageIdBySubscriptions = (salePackageId: number, subscriptions: number[]): IRequest => ({
    uri: `v1/tariffs/${salePackageId}/package-id-by-subscriptions`,
    method: 'GET',
    queryParams: {
        subscriptions,
    },
    withProvider: true,
});

export default getPackageIdBySubscriptions;
